export default {
    GETTINGACCESSTOKEN: "gettingaccesstoken",
    SENDINGREQUEST: "sendingrequest",
    SENTREQUEST: "sentrequest"
}